import React from 'react';
import { View, Image } from 'react-native';
import Text from '../../common/component/CustomTextComponent';
import { THEME_COLORS, images } from '../../common/themes';

interface ErrorMsgInterface{
    errorMsg:string;
    showBox:boolean;
}

const ErrorMsg=(props:ErrorMsgInterface)=>{

    const { errorMsg, showBox } = props;

    const boxStyles = !!showBox ? {padding:10,borderWidth:1,borderColor:THEME_COLORS.orange} : {};

    return (
        <View style={{flexDirection:"row",marginVertical:10,...boxStyles}}>
            <Image source={ images.errorIcon } style={{width:15,height:15}}/>
            <Text fontSize={'small'} style={{marginLeft:10,color:THEME_COLORS.orange}}>{errorMsg ?? ""}</Text>
        </View>
    )
}

export default ErrorMsg;